import styled from 'styled-components';
import { StyledBlockTitle } from './styled-document-elemets';

export const StyledContainerArticle = styled.div`
  margin-bottom: 40px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  span {
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 700;
    color: ${({ theme }) => theme && theme.defaultColor};
  }
  ${StyledBlockTitle} {
    color: ${({ theme }) => theme && theme.text};
  }
  ol {
    padding-left: 15px;
    li {
      :hover {
        color: ${({ theme }) => theme && theme.defaultColor};
        ::before {
          color: ${({ theme }) => theme && theme.text};
        }
      }
    }
  }
`